// src/pages/About.js
import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence, useMotionValue, useTransform } from "framer-motion";
import { useNavigate } from "react-router-dom";
import profilePic from '../assets/IMG_1267.jpg';
import ioaImg from '../assets/Institute of Analytics Student Member.jpeg';
import scoutImg1 from '../assets/Licenses and Certifications Aayam Bhattarai (1).jpeg';
import scoutImg2 from '../assets/Licenses and Certifications Aayam Bhattarai (2).jpeg';
import dataAnalystPythonImg from '../assets/cert-data-analyst-in-python.jpg';
import intermediatePythonImg from '../assets/cert-intermediate-python.jpg';
import introToSQLImg from '../assets/cert-introduction-to-sql.jpg';
import introToDataLiteracyImg from '../assets/cert-introduction-to-data-literacy.jpg';
import dataManipulationPandasImg from '../assets/cert-data-manipulation-with-pandas.jpg';
import dataLiteracyCertImg from '../assets/cert-data-literacy-certificate.jpg';
import expoImg1 from '../assets/silder/06614710-84bf-471c-aa6a-7866d8bb1814.JPG';
import expoImg2 from '../assets/silder/IMG_1557.JPG';
import expoVid1 from '../assets/silder/9BD5BF4F-9C49-4C5F-9763-1DC1F0E5AE67.MP4';
import expoVid2 from '../assets/silder/IMG_1359.MOV';
import expoVid3 from '../assets/silder/IMG_1361.MOV';
import expoVid4 from '../assets/silder/IMG_1365.MOV';
import {
  FaGithub, FaLinkedin, FaEnvelope,
  FaTrophy, FaCode, FaGraduationCap, FaDownload, FaPaperPlane,
  FaUser, FaBriefcase, FaMapMarkerAlt, FaGlobe,
  FaDatabase, FaChartBar, FaCertificate,
  FaImages, FaPlayCircle, FaCameraRetro, FaCalendarAlt,
  FaInfoCircle,
} from "react-icons/fa";
/* Official brand logos (Simple Icons) */
import {
  SiHtml5, SiJavascript, SiGit, SiFigma, SiReact, SiNodedotjs,
  SiPython, SiMongodb, SiExpress, SiFirebase, SiAndroid, SiOpenjdk,
  SiFlutter, SiTensorflow, SiSocketdotio, SiCloudflare, SiTrello,
  SiJupyter,
} from "react-icons/si";


const TABS = [
  { id: "about",        icon: FaUser,        label: "About"        },
  { id: "experience",   icon: FaCalendarAlt, label: "Experience"   },
  { id: "skills",       icon: FaCode,        label: "Skills"       },
  { id: "achievements", icon: FaTrophy,      label: "Certs"        },
  { id: "memories",     icon: FaImages,      label: "Memories"     },
];

export const SKILLS = [
  { name: "HTML / CSS",   pct: 88, icon: SiHtml5,      color: "#e44d26", tag: "Expert"  },
  { name: "JavaScript",   pct: 85, icon: SiJavascript, color: "#f7df1e", tag: "Core"    },
  { name: "Git",          pct: 80, icon: SiGit,        color: "#f05032", tag: "DevOps"  },
  { name: "UI / UX",      pct: 75, icon: SiFigma,      color: "#a78bfa", tag: "Design"  },
  { name: "React",        pct: 70, icon: SiReact,      color: "#61dafb", tag: "Growing" },
  { name: "Node.js",      pct: 70, icon: SiNodedotjs,  color: "#68a063", tag: "Backend" },
  { name: "Python",       pct: 78, icon: SiPython,     color: "#4b8bbe", tag: "Data Science" },
  { name: "MongoDB",      pct: 74, icon: SiMongodb,    color: "#47a248", tag: "Database" },
  { name: "Express.js",   pct: 72, icon: SiExpress,    color: "#d1d5db", tag: "Backend" },
  { name: "Firebase",     pct: 70, icon: SiFirebase,   color: "#ffca28", tag: "Backend" },
  { name: "Android",      pct: 68, icon: SiAndroid,    color: "#3ddc84", tag: "Mobile"  },
  { name: "Java",         pct: 65, icon: SiOpenjdk,    color: "#f89820", tag: "Mobile"  },
  { name: "Flutter",      pct: 60, icon: SiFlutter,    color: "#47c5fb", tag: "Mobile"  },
  { name: "TensorFlow",   pct: 62, icon: SiTensorflow, color: "#ff6f00", tag: "ML"      },
  { name: "Socket.io",    pct: 65, icon: SiSocketdotio,color: "#e5e7eb", tag: "Realtime" },
  { name: "Cloudflare",   pct: 60, icon: SiCloudflare, color: "#f38020", tag: "Infra"    },
  { name: "Trello",       pct: 75, icon: SiTrello,     color: "#0079bf", tag: "Project Mgmt" },
  { name: "Klaviyo",      pct: 55, icon: FaPaperPlane, color: "#00d4aa", tag: "Marketing" }, /* no Klaviyo logo in the icon set */
  { name: "Jupyter Notebook", pct: 72, icon: SiJupyter, color: "#f37626", tag: "Data Science" },
];

export const ACHIEVEMENTS = [
  { icon: FaGraduationCap, title: "IoA: Institute of Analytics",         desc: "Student Member demonstrating commitment to data analytics and professional development.", year: "2024", cat: "Membership",       img: ioaImg,    accent: "#63cab7" },
  { icon: FaTrophy,        title: "Scouting & Recruitment: Module 1",    desc: "Positional analysis and player recruitment fundamentals in professional football.",           year: "2024", cat: "Football Scouting", img: scoutImg1, accent: "#f59e0b" },
  { icon: FaTrophy,        title: "Scouting & Recruitment: Module 2",    desc: "Advanced strategies in football scouting, building on Module 1 foundations.",                year: "2024", cat: "Football Scouting", img: scoutImg2, accent: "#f59e0b" },
  { icon: FaChartBar,      title: "Data Analyst in Python",              desc: "36-hour DataCamp track covering Python-based data analysis, cleaning, and visualization.",   year: "2026", cat: "Data Analytics", img: dataAnalystPythonImg, accent: "#3b82f6" },
  { icon: FaCode,          title: "Intermediate Python",                 desc: "DataCamp course on functions, loops, and data structures for real-world Python programs.",   year: "2026", cat: "Programming",   img: intermediatePythonImg, accent: "#3776ab" },
  { icon: FaDatabase,      title: "Introduction to SQL",                 desc: "DataCamp fundamentals of querying and managing relational databases with SQL.",              year: "2026", cat: "Data Analytics", img: introToSQLImg, accent: "#00758f" },
  { icon: FaCertificate,   title: "Introduction to Data Literacy",       desc: "DataCamp foundations of interpreting, communicating, and reasoning with data.",             year: "2026", cat: "Data Analytics", img: introToDataLiteracyImg, accent: "#8b5cf6" },
  { icon: FaChartBar,      title: "Data Manipulation with pandas",       desc: "DataCamp course on transforming, filtering, and aggregating data using pandas.",            year: "2026", cat: "Data Analytics", img: dataManipulationPandasImg, accent: "#150458" },
  { icon: FaCertificate,   title: "Data Literacy: Fundamentals Certification", desc: "DataCamp certification confirming core data literacy skills and concepts.",            year: "2026", cat: "Certification",  img: dataLiteracyCertImg, accent: "#f59e0b" },
];

/* Photos & videos from expos and other moments worth keeping.
   Add files to src/assets/silder/, import them above, then add an entry here:
   { type: "image", src: yourImg, event: "IPITEX 2026", caption: "..." }
   { type: "video", src: yourVid, event: "IPITEX 2026", caption: "..." }              */
export const MEMORIES = [
  { type: "image", src: expoImg1, event: "IPITEX 2026", caption: "At the IPITEX exhibition floor in Bangkok" },
  { type: "image", src: expoImg2, event: "IPITEX 2026", caption: "Checking out the innovations on display" },
  { type: "video", src: expoVid1, event: "IPITEX 2026", caption: "" },
  { type: "video", src: expoVid2, event: "IPITEX 2026", caption: "" },
  { type: "video", src: expoVid3, event: "IPITEX 2026", caption: "" },
  { type: "video", src: expoVid4, event: "IPITEX 2026", caption: "" },
];

/* Work history, internships, and freelance roles.
   Add an entry here for each: side alternates l/r automatically by index.
   { year: "2025 — Present", title: "Role title", org: "Company name",
     desc: "What you did / impact you had, 1-2 sentences.",
     tags: ["React","Node.js"] }                                          */
export const EXPERIENCE = [
  {
    year: "Present",
    title: "Founder",
    org: "Retainovo",
    desc: "Retainovo builds and runs the flows and campaigns in your Klaviyo account. Strategy, copy, design and reporting, all handled by one team.",
    tags: ["Email Marketing", "Klaviyo", "Agency"],
    logo: "retainovo", /* file: src/assets/experience/retainovo.png (or .jpg, .webp, .svg) */
    logoZoom: true, /* this image has lots of empty margin: crop in to the wordmark */
  },
  {
    year: "2025",
    title: "Freelance Web Developer",
    org: "Self-employed",
    desc: "Independently designed, built, and deployed a complete e-commerce website for a friend's company, from UI/UX design through to a live, working site. Owned the project end-to-end as a solo freelancer: requirements gathering, front-end development, and deployment.",
    tags: ["UI/UX Design", "Frontend Development", "Deployment"],
  },
];

const INFO = [
  { icon: FaMapMarkerAlt, label: "Location",   value: "Bhaktapur, Nepal"      },
  { icon: FaGraduationCap,label: "Education",  value: "BSc Computing (Hons)" },
  { icon: FaBriefcase,    label: "Experience", value: "2+ Years"             },
  { icon: FaGlobe,        label: "Languages",  value: "English · Nepali"     },
  { icon: FaEnvelope,     label: "Email",      value: "aayambht@gmail.com"   },
];

const fade  = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0 } };
const stagger = { show: { transition: { staggerChildren: 0.08 } } };

/* ── 3D tilt wrapper: subtle pointer-reactive depth for cards ── */
function Tilt3D({ children, className = "", maxTilt = 8 }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-0.5, 0.5], [maxTilt, -maxTilt]);
  const rotateY = useTransform(x, [-0.5, 0.5], [-maxTilt, maxTilt]);

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - rect.left) / rect.width - 0.5);
    y.set((e.clientY - rect.top) / rect.height - 0.5);
  };
  const handleLeave = () => { x.set(0); y.set(0); };

  return (
    <motion.div
      ref={ref}
      className={className}
      style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      transition={{ type: "spring", stiffness: 200, damping: 18 }}
    >
      {children}
    </motion.div>
  );
}

/* ── Achievement card with pointer-reactive 3D tilt ── */
function AchievementCard({ a, i, onOpen }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-0.5, 0.5], [7, -7]);
  const rotateY = useTransform(x, [-0.5, 0.5], [-7, 7]);

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - rect.left) / rect.width - 0.5);
    y.set((e.clientY - rect.top) / rect.height - 0.5);
  };
  const handleLeave = () => { x.set(0); y.set(0); };

  return (
    <motion.div
      ref={ref}
      className="ach-card"
      style={{ "--a": a.accent, rotateX, rotateY, transformStyle: "preserve-3d" }}
      initial={{ opacity:0, y:28 }} animate={{ opacity:1, y:0 }}
      transition={{ delay: i*0.12 }}
      whileHover={{ y:-8, scale:1.015 }}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      <div className="ach-img-wrap" onClick={() => onOpen(a.img)} style={{ transform:"translateZ(26px)" }}>
        <img src={a.img} alt={a.title} className="ach-img" />
        <div className="ach-overlay"><span>⤢ View</span></div>
      </div>
      <div className="ach-body" style={{ transform:"translateZ(16px)" }}>
        <div className="ach-icon"><a.icon /></div>
        <h3 className="ach-title">{a.title}</h3>
        <p className="ach-desc">{a.desc}</p>
        <div className="ach-tags">
          <span className="badge badge--year">{a.year}</span>
          <span className="badge badge--cat">{a.cat}</span>
        </div>
      </div>
    </motion.div>
  );
}

/* ── Media card for the Memories gallery: image or video, pointer-reactive tilt ── */
function MemoryCard({ m, i, onOpen }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-0.5, 0.5], [6, -6]);
  const rotateY = useTransform(x, [-0.5, 0.5], [-6, 6]);

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - rect.left) / rect.width - 0.5);
    y.set((e.clientY - rect.top) / rect.height - 0.5);
  };
  const handleLeave = () => { x.set(0); y.set(0); };

  return (
    <motion.div
      ref={ref}
      className="media-card"
      style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
      initial={{ opacity:0, y:28 }} animate={{ opacity:1, y:0 }}
      transition={{ delay: i*0.08 }}
      whileHover={{ y:-6, scale:1.015 }}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      onClick={() => onOpen(m)}
    >
      <div className="media-thumb">
        {m.type === "video" ? (
          <>
            <video src={m.src} className="media-el" muted playsInline />
            <span className="media-play-badge"><FaPlayCircle /></span>
          </>
        ) : (
          <img src={m.src} alt={m.caption || m.event} className="media-el" />
        )}
        <div className="media-overlay"><span>⤤ View</span></div>
      </div>
      <div className="media-cap">
        <span className="media-event">{m.event}</span>
        {m.caption && <span className="media-caption">{m.caption}</span>}
      </div>
    </motion.div>
  );
}

const levelOf = (p) =>
  p >= 85 ? "Advanced" : p >= 75 ? "Proficient" : p >= 65 ? "Intermediate" : "Learning";

/* ── Premium skill card: brand logo, animated ring, pointer-reactive tilt ── */
function SkillCard({ s, i }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-0.5, 0.5], [6, -6]);
  const rotateY = useTransform(x, [-0.5, 0.5], [-6, 6]);
  const R = 26;
  const C = 2 * Math.PI * R;

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - rect.left) / rect.width - 0.5);
    y.set((e.clientY - rect.top) / rect.height - 0.5);
  };
  const handleLeave = () => { x.set(0); y.set(0); };

  return (
    <motion.div
      ref={ref}
      className="sk-card"
      style={{ "--c": s.color, rotateX, rotateY, transformStyle: "preserve-3d" }}
      initial={{ opacity: 0, y: 26 }} animate={{ opacity: 1, y: 0 }}
      transition={{ delay: i * 0.05, duration: 0.5 }}
      whileHover={{ y: -6 }}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      <div className="sk-glow" />
      <div className="sk-top">
        <div className="sk-logo" style={{ transform: "translateZ(26px)" }}>
          <s.icon />
        </div>
        <div className="sk-ring" style={{ transform: "translateZ(18px)" }}>
          <svg viewBox="0 0 64 64">
            <circle className="sk-ring-bg" cx="32" cy="32" r={R} />
            <motion.circle
              className="sk-ring-fg" cx="32" cy="32" r={R}
              style={{ stroke: s.color }}
              strokeDasharray={C}
              initial={{ strokeDashoffset: C }}
              animate={{ strokeDashoffset: C * (1 - s.pct / 100) }}
              transition={{ duration: 1.2, delay: 0.25 + i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            />
          </svg>
          <span className="sk-ring-val">{s.pct}<small>%</small></span>
        </div>
      </div>
      <h3 className="sk-card-name">{s.name}</h3>
      <div className="sk-card-foot">
        <span className="sk-card-tag">{s.tag}</span>
        <span className="sk-level">{levelOf(s.pct)}</span>
      </div>
    </motion.div>
  );
}

export default function About() {
  const [tab, setTab]     = useState("about");
  const [lb, setLb]       = useState(null);
  const [mlb, setMlb]     = useState(null);
  const navigate          = useNavigate();

  useEffect(() => { document.title = "Aayam Bhattarai — Frontend Developer"; }, []);

  return (
    <div className="pg">

      <section className="hero">
        <div className="hero-grid" />
        <div className="hero-blob hero-blob--a" />
        <div className="hero-blob hero-blob--b" />

        <div className="hero-wrap">
          <motion.div className="hero-left"
            variants={stagger} initial="hidden" animate="show">

            <motion.p className="hero-eyebrow" variants={fade}>
              <span className="pulse-dot" />
              Available for opportunities
            </motion.p>

            <motion.h1 className="hero-h1" variants={fade}>
              Hey, It's me<br />
              <span className="hero-name">Aayam</span>
            </motion.h1>

            <motion.p className="hero-bio" variants={fade}>
              Whether I'm breaking down a defense on the pitch,
              debugging a stubborn script, or riding through nature's quiet paths.
            </motion.p>

            <motion.p className="hero-kw-line" variants={fade}>
              I'm all about{" "}
              <span className="hero-kw hero-kw--passion">passion</span>
              <span className="hero-kw-sep">,</span>{" "}
              <span className="hero-kw hero-kw--precision">precision</span>
              <span className="hero-kw-sep">,</span>{" and "}
              <span className="hero-kw hero-kw--discovery">discovery.</span>
            </motion.p>

            <motion.div className="hero-chips" variants={fade}>
              {["⚽ Football","💻 Coding","🌿 Nature","📊 Data"].map(c => (
                <span key={c} className="chip">{c}</span>
              ))}
            </motion.div>

            <motion.div className="hero-ctas" variants={fade}>
              <motion.a href="/Aayam_Bhattarai_CV.pdf" download="Aayam_Bhattarai_CV.pdf"
                className="cta cta--solid"
                whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
                <FaDownload /> Download CV
              </motion.a>
              <motion.button className="cta cta--outline"
                whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}
                onClick={() => navigate('/contact')}>
                <FaPaperPlane /> Get In Touch
              </motion.button>
            </motion.div>
          </motion.div>

          <motion.div className="hero-right"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.16,1,0.3,1], delay: 0.15 }}>

            <Tilt3D className="photo-shell" maxTilt={12}>
              <div className="photo-ring photo-ring--outer" />
              <div className="photo-ring photo-ring--inner" />
              <img src={profilePic} alt="Aayam Bhattarai" className="photo-img" style={{ transform:"translateZ(40px)" }} />

              <motion.div className="photo-badge"
                initial={{ opacity:0, y:10 }} animate={{ opacity:1, y:0 }}
                transition={{ delay:0.7 }}
                style={{ transform:"translateZ(60px)" }}>
                <span className="pulse-dot" /> Available
              </motion.div>

              <motion.div className="stat-chip stat-chip--br"
                initial={{ opacity:0, scale:0.8 }} animate={{ opacity:1, scale:1 }}
                transition={{ delay:1 }}
                style={{ transform:"translateZ(50px)" }}>
                <b>{ACHIEVEMENTS.length}</b>
                <span>Certifications</span>
              </motion.div>

            </Tilt3D>
          </motion.div>
        </div>

        <motion.div className="info-strip"
          initial={{ opacity:0 }} animate={{ opacity:1 }}
          transition={{ delay:0.6 }}>
          {INFO.map(({ icon: Icon, label, value }) => (
            <div key={label} className="info-cell">
              <Icon className="info-icon" />
              <span className="info-label">{label}</span>
              <span className="info-val">{value}</span>
            </div>
          ))}
        </motion.div>
      </section>

      <nav className="tabs-bar">
        <div className="tabs-inner">
          {TABS.map(({ id, icon: Icon, label }) => (
            <button
              key={id}
              className={`tab${tab === id ? " tab--on" : ""}`}
              onClick={() => setTab(id)}
            >
              <Icon />
              <span>{label}</span>
              {tab === id && <motion.div className="tab-line" layoutId="tl" />}
            </button>
          ))}
        </div>
      </nav>

      <main className="content">
        <AnimatePresence mode="wait">
          {tab === "about" && (
            <motion.div key="about" className="panel"
              initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }}
              exit={{ opacity:0, y:-16 }} transition={{ duration:0.35 }}>

              <div className="about-duo">
                <Tilt3D className="glass-card" maxTilt={5}>
                  <span className="code-tag">{'// who_am_i'}</span>
                  <h2 className="card-h2">A builder<br/>at heart</h2>
                  <p className="card-p">
                    I'm <strong>Aayam Bhattarai</strong>, a frontend developer who loves crafting
                    fast, clean, and elegant web experiences. Whether it's a pixel-perfect UI,
                    a data-driven football dashboard, or a full-stack app, I bring the same
                    energy I have on the pitch: focused, creative, always pushing forward.
                  </p>
                  <div className="social-row">
                    <a href="https://github.com/aayam17" target="_blank" rel="noopener noreferrer" className="soc soc--gh"><FaGithub/>GitHub</a>
                    <a href="https://np.linkedin.com/in/aayam-bhattarai-1ba53b343" target="_blank" rel="noopener noreferrer" className="soc soc--li"><FaLinkedin/>LinkedIn</a>
                    <a href="mailto:aayambht@gmail.com" className="soc soc--em"><FaEnvelope/>Email</a>
                  </div>
                </Tilt3D>

                <Tilt3D className="glass-card" maxTilt={5}>
                  <span className="code-tag">{'// tech_stack'}</span>
                  <h2 className="card-h2">Tools I use</h2>
                  <div className="pill-grid">
                    {SKILLS.map((s,i) => (
                      <motion.div key={s.name} className="skill-pill"
                        style={{ "--c": s.color }}
                        initial={{ opacity:0, scale:0.85 }}
                        animate={{ opacity:1, scale:1 }}
                        transition={{ delay: i * 0.07 }}
                        whileHover={{ y:-3, scale:1.06 }}>
                        <s.icon style={{ color: s.color }} />
                        <span>{s.name}</span>
                      </motion.div>
                    ))}
                  </div>
                </Tilt3D>
              </div>
            </motion.div>
          )}

          {tab === "experience" && (
            <motion.div key="experience" className="panel"
              initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }}
              exit={{ opacity:0, y:-16 }} transition={{ duration:0.35 }}>

              <div className="section-head">
                <h2 className="section-h2">Experience</h2>
                <p className="section-sub">Roles, internships, and freelance work along the way</p>
              </div>

              {EXPERIENCE.length > 0 ? (
                <div className="tl-wrap">
                  <div className="tl-spine" />
                  {EXPERIENCE.map((e, i) => (
                    <motion.div key={i}
                      className={`tl-item ${i % 2 === 0 ? "tl-item--r" : "tl-item--l"}`}
                      initial={{ opacity:0, y:24 }} animate={{ opacity:1, y:0 }}
                      transition={{ delay: i * 0.12 }}>
                      <div className="tl-node"><FaBriefcase /></div>
                      <div className="tl-card">
                        <span className="tl-year">{e.year}</span>
                        <h3 className="tl-title">{e.title}</h3>
                        <p className="tl-org">{e.org}</p>
                        <p className="tl-desc">{e.desc}</p>
                        {e.tags && (
                          <div className="tl-tags">
                            {e.tags.map(t => <span key={t} className="tl-tag">{t}</span>)}
                          </div>
                        )}
                      </div>
                    </motion.div>
                  ))}
                </div>
              ) : (
                <div className="media-empty">
                  <FaBriefcase size={40} />
                  <h3>Experience coming soon</h3>
                  <p>Roles and internships will show up here shortly.</p>
                </div>
              )}
            </motion.div>
          )}

          {tab === "skills" && (
            <motion.div key="skills" className="panel"
              initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }}
              exit={{ opacity:0, y:-16 }} transition={{ duration:0.35 }}>

              <div className="section-head">
                <h2 className="section-h2">Skills & Tools</h2>
                <p className="section-sub">Technologies I've worked with across real projects</p>
                <div className="sk-note">
                  <FaInfoCircle />
                  <span>Percentages are my own self-assessment, not a formal test.</span>
                </div>
              </div>

              <div className="sk-grid">
                {SKILLS.map((s, i) => (
                  <SkillCard key={s.name} s={s} i={i} />
                ))}
              </div>
            </motion.div>
          )}

          {tab === "achievements" && (
            <motion.div key="achievements" className="panel"
              initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }}
              exit={{ opacity:0, y:-16 }} transition={{ duration:0.35 }}>

              <div className="ach-grid">
                {ACHIEVEMENTS.map((a,i) => (
                  <AchievementCard key={i} a={a} i={i} onOpen={setLb} />
                ))}
              </div>
            </motion.div>
          )}

          {tab === "memories" && (
            <motion.div key="memories" className="panel"
              initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }}
              exit={{ opacity:0, y:-16 }} transition={{ duration:0.35 }}>

              <div className="section-head">
                <h2 className="section-h2">Memories & Tech Expo</h2>
                <p className="section-sub">Moments from IPITEX 2026 — Bangkok International Intellectual Property, Invention, Innovation and Technology Exposition, and other adventures along the way.</p>
              </div>

              {MEMORIES.length > 0 ? (
                <div className="media-grid">
                  {MEMORIES.map((m,i) => (
                    <MemoryCard key={i} m={m} i={i} onOpen={setMlb} />
                  ))}
                </div>
              ) : (
                <div className="media-empty">
                  <FaCameraRetro size={40} />
                  <h3>Photos & videos coming soon</h3>
                  <p>Snapshots from IPITEX 2026 in Bangkok will show up here shortly.</p>
                </div>
              )}
            </motion.div>
          )}

        </AnimatePresence>
      </main>

      <AnimatePresence>
        {lb && (
          <motion.div className="lightbox"
            initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
            onClick={() => setLb(null)}>
            <motion.div className="lb-box"
              initial={{ scale:0.75 }} animate={{ scale:1 }} exit={{ scale:0.75 }}
              transition={{ type:"spring", stiffness:300, damping:26 }}
              onClick={e => e.stopPropagation()}>
              <button className="lb-close" onClick={() => setLb(null)}>✕</button>
              <img src={lb} alt="Certificate" className="lb-img" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {mlb && (
          <motion.div className="lightbox"
            initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
            onClick={() => setMlb(null)}>
            <motion.div className="lb-box"
              initial={{ scale:0.75 }} animate={{ scale:1 }} exit={{ scale:0.75 }}
              transition={{ type:"spring", stiffness:300, damping:26 }}
              onClick={e => e.stopPropagation()}>
              <button className="lb-close" onClick={() => setMlb(null)}>✕</button>
              {mlb.type === "video" ? (
                <video src={mlb.src} className="lb-img" controls autoPlay />
              ) : (
                <img src={mlb.src} alt={mlb.caption || mlb.event} className="lb-img" />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
